import { render, staticRenderFns } from "./RawMaterialStockList.vue?vue&type=template&id=f8847ff2&scoped=true&"
import script from "./RawMaterialStockList.vue?vue&type=script&lang=js&"
export * from "./RawMaterialStockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8847ff2",
  null
  
)

export default component.exports